document.addEventListener("DOMContentLoaded", function () {
  var formSubmit = document.querySelector(".product-tabs-pdp");
  var stickyAdd = document.querySelector(".product-sticky-add");
  var drawer = document.querySelector(".drawer");

  if (formSubmit && stickyAdd && drawer) {
    window.addEventListener("scroll", function () {
      var formSubmit = document.querySelector(".product-form__submit");
      var stickyAdd = document.querySelector(".product-sticky-add");
      var drawer = document.querySelector(".drawer");

      if (!formSubmit || !stickyAdd || !drawer) {
        return; // Exit if any required element is not found
      }

      var rect = formSubmit.getBoundingClientRect();
      var shouldHideStickyBar = drawer.classList.contains("active");

      if (shouldHideStickyBar) {
        // Condition 1: Hide stickyAdd if drawer is active
        hideStickyAdd();
      } else if (rect.top < window.innerHeight && rect.bottom > 0) {
        // Condition 2: Hide stickyAdd if formSubmit is in view
        hideStickyAdd();
      } else if (rect.top < 0) {
        // Condition 3: Show stickyAdd when formSubmit is scrolled past
        showStickyAdd();
      } else {
        // Condition 4: Hide stickyAdd in all other cases
        hideStickyAdd();
      }

      updateActiveTab();

      function showStickyAdd() {
        stickyAdd.style.opacity = 1;
        stickyAdd.style.visibility = "visible";
        stickyAdd.style.pointerEvents = "auto";
      }

      function hideStickyAdd() {
        stickyAdd.style.opacity = 0;
        stickyAdd.style.visibility = "hidden";
        stickyAdd.style.pointerEvents = "none";
      }
    });

    var buttons = stickyAdd.querySelectorAll(".button");
    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        stickyAdd.style.opacity = 0;
        stickyAdd.style.visibility = "hidden";
      });
    });

    var topTabs = document.querySelectorAll(".product-tabs a");
    var stickyTabs = document.querySelectorAll(
      ".product-sticky-add .product-tabs a"
    );
    var activeTab = null;
    var sections = [];

    function setupTabs(tabs) {
      tabs.forEach(function (link) {
        var targetId = link.getAttribute("href").substring(1);
        var targetElement = document.getElementById(targetId);
        if (targetElement) {
          sections.push({ id: targetId, element: targetElement, link: link });

          link.addEventListener("click", function (event) {
            event.preventDefault();
            setActiveTab(link);

            var offsetPosition =
              targetElement.getBoundingClientRect().top + window.scrollY;

            if (link.closest(".product-sticky-add")) {
              offsetPosition -= stickyAdd.offsetHeight;
            }

            window.scrollTo({
              top: offsetPosition,
              behavior: "smooth",
            });
          });
        }
      });
    }

    function setActiveTab(link) {
      if (activeTab) {
        activeTab.style.borderBottom = "none";
      }

      link.style.borderBottom = "2px solid #F93822";
      activeTab = link;

      // Synchronize the other set of tabs
      var targetId = link.getAttribute("href").substring(1);
      [topTabs, stickyTabs].forEach(function (tabs) {
        tabs.forEach(function (tab) {
          if (
            tab.getAttribute("href").substring(1) === targetId &&
            tab !== link
          ) {
            tab.style.borderBottom = "2px solid #F93822";
          } else if (tab !== link) {
            tab.style.borderBottom = "none";
          }
        });
      });
    }

    function updateActiveTab() {
      var fromTop =
        window.scrollY +
        (stickyAdd.style.opacity === "1" ? stickyAdd.offsetHeight : 0) +
        (stickyAdd.style.visibility === "visible" ? stickyAdd.offsetHeight : 0);

      sections.forEach(function (section) {
        var sectionTop = section.element.offsetTop;
        var sectionHeight = section.element.offsetHeight;

        if (fromTop >= sectionTop && fromTop < sectionTop + sectionHeight) {
          setActiveTab(section.link);
        }
      });
    }

    setupTabs(topTabs);
    setupTabs(stickyTabs);
    updateActiveTab();
  }
});

document.querySelectorAll('.product__media-wrapper .product-tabs a').forEach(anchor => {
  anchor.addEventListener('click', function(e) {
    e.preventDefault();
    const targetId = this.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const announcementBar = document.querySelector('.essential_countdown_annoucement_bar_wrapper'); 
      const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
      const offsetPosition = targetPosition - 120; 

      console.log('Current scroll:', window.scrollY);
      console.log('Target element:', targetElement);
      console.log('Target position:', targetPosition);
      console.log('Announcement height:', announcementHeight);
      console.log('Final offset position (adjusted for visibility):', offsetPosition);
      
      setTimeout(() => {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }, 100);
    }
  });
});